'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CheckboxGroup = require('./CheckboxGroup');

Object.keys(_CheckboxGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CheckboxGroup[key];
    }
  });
});